import * as Constants from './Constants';
import { performanceMeasure } from '../../components/common/Helpers/performanceMeasure';

const initialState = {
  isFetching: false,
  showAddressError: false,
  isCartVisible: true,
  isCartPageView: false,
  cartDetailsJson: '',
  updateSetup: false,
  validateOrder: null,
  enableContinueBtn: false,
  proceedToNext: false,
  showErorr: false,
  autoPayText: '',
  email: '',
  phone: '',
  updatecartAALSuccess: false,
  updateProcessStep: '',
  saveCart: true,
  validateCart: '',
  needValidateCart: false,
  isQuantityChanged: false,
  showCartApiError: false,
  loadingDone: false,
  showSaveCart: false,
  cartInvalidCaseError: false,
  apiStatus: null,
  callNbsApi: false,
  redirectToPlans: [],
  isEmptyAddress: false,
  cartError: false,
  updatePromocodeFailed: false,
  cartNtfyMsg: null,
  creditStatusTagging: false,
  notifyErrorMsg: '',
  isValidateOrderFailed: false,
  fwaOfferRecommendations: {},
  giftCardFwaOfferRecommendations: {},
  showNoDatesErrorforReviewOrderPage: false,
  save5GappointmentStatus: false,
  prefetchRetrieveCartInSetupStatus: null,
  prefetchOrderReviewCart: null,
  prefetchIsSetupChange: false,
  showStreamlineMiniCart: false,
  updateBarCodeResponse: {},
  nbxFeedbackResponse: {},
};
function cartDetails(state = initialState, action) {
  switch (action.type) {
    case Constants.FETCH_AUTOFILL_ADDRESS_FAILURE:
      return { ...state, showAddressError: action.errorDetails };
    case Constants.FETCH_AUTOFILL_ADDRESS_SUCCESS:
      return { ...state, availableAddress: action.apiResponse };
    case Constants.FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE:
      return { ...state, showAddressErrorUnit: action.errorDetails };
    case Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS:
      return { ...state, availableAddressUnit: action.apiResponse };
    case Constants.FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2:
      return { ...state, availableAddressUnit2: action.apiResponse };
    case Constants.FETCH_APPCONFIG_API_SUCCESS:
      return { ...state, appConfig: action.apiResponse };
    case Constants.GET_CART_SUCCESS:
      return { ...state, cartDetailsJson: action.response, stateCache: Date.now(), isFetching: true };
    case 'UPDATE_API_STATUS':
      return { ...state, apiStatus: action.response };
    case 'PREFETCH_ORDERREVIEW_STATUS':
      return { ...state, prefetchOrderReviewCart: action.response };
    case 'CEF_APPOINTMENT_ERROR':
      return { ...state, appointmentError: action.response, appointmentNtfyMsg: action.errorMessage };
    case Constants.UPDATE_SHOW_CART: {
      return { ...state, isCartVisible: action.data };
    }
    case Constants.CHECKOUT_DETAILS_RESPONSE: {
      return { ...state, checkoutResponse: action.response };
    }
    case Constants.CHECKOUT_DETAILS_SUCCESS: {
      return { ...state, checkoutSuccess: action.response };
    }
    case Constants.ERORR_CART:
      return { ...state, showErorr: action.errorDetails };
    case Constants.SHOW_PAGE: {
      return { ...state, isCartPageView: action.data };
    }
    case Constants.UPDATE_INSTALL_TYPE_SUUCESS: {
      const preState = state.updateSetup;
      return { ...state, updateSetup: !preState };
    }
    case Constants.UPDATE_INSTALL_TYPE_SUUCESS_MV: {
      const preState = state.updateSetupMV;
      return { ...state, updateSetupMV: !preState };
    }
    case Constants.UPDATE_VALIDATE_ORDER: {
      return { ...state, validateOrder: action.response };
    }
    case Constants.ENABLE_CNT_BTN: {
      return { ...state, enableContinueBtn: action.response };
    }
    case Constants.PROCEED_TO_NEXT: {
      return { ...state, proceedToNext: action.response };
    }
    case Constants.AUTOPAY_TEXT: {
      return { ...state, autoPayText: action.data };
    }
    case 'SET_EMAIL_PHONE':
      return { ...state, email: action.response.email, phone: action.response.phone };
    case 'UPDATE_CART_AAL_SUCCESS_FLAG':
      return { ...state, updatecartAALSuccess: action.response };
    case Constants.UPDATE_CART_API_SUCCESS:
      return { ...state, updatecartAPISuccess: action.response };
    case 'SAVE_CART':
      return { ...state, saveCart: action.data };
    case 'UPDATE_CART_AAL_SUCCESS_FLAG_RESET':
      return { ...state, updatecartAALSuccess: action.data };
    case Constants.RESET_ON_START_NEW_ORDER:
      return { ...state, ...initialState };
    case 'UPDATE_PROCESS_STEP':
      return { ...state, updateProcessStep: action.response };
    case Constants.VALIDATECART_RESPONSE: {
      return { ...state, validateCart: action.response };
    }
    case Constants.RESET_VALIDATE_CART: {
      return { ...state, validateCart: action.data };
    }
    case Constants.NEED_VALIDATE_CART: {
      return { ...state, needValidateCart: action.data };
    }
    case Constants.QUANTITY_CHANGED: {
      return { ...state, isQuantityChanged: action.data };
    }
    case Constants.SHOW_CART_API_ERROR: {
      return { ...state, showCartApiError: action.errorDetails, notifyErrorMsg: action.notifyErrorMsg };
    }
    case Constants.PREORDER: {
      return { ...state, isPreorder: action.response };
    }
    case Constants.GET_DETAILS_SHIPPING_API_SUCCESS:
      return { ...state, ShippingInfoDetails: action.response };
    case Constants.COUPIN_VALID_SUCCESS:
      return { ...state, validCouponResponse: action.response, apiFailed: action.apiFailed };
    case 'COUPON_CODE':
      return { ...state, couponCodevalue: action.response };
    case Constants.CLEAR_VALID_COUPON_RESPONSE:
      return { ...state, validCouponResponse: {} };
    case Constants.CLEAR_COUPON_VALUE:
      return { ...state, couponCodevalue: null, validCouponResponse: {} };
    case Constants.LOADING_DONE:
      return { ...state, loadingDone: action.response };
    case Constants.CONFIRMATION_RETRIEVE_CART:
      return { ...state, confirmationRetrieveCart: action?.response };
    case 'SHOW_SAVE_CART':
      return { ...state, showSaveCart: action?.data };
    case Constants.CART_INVALIDCASE_ERROR: {
      return { ...state, cartInvalidCaseError: action.response };
    }
    case Constants.UPDATE_SAVE_CART_SUCCESS: {
      return { ...state, saveCartSuccessData: action.response };
    }
    case 'CALL_NBS_API': {
      return { ...state, callNbsApi: action.response };
    }
    case 'REDIRECT_TO_PLANS': {
      return { ...state, redirectToPlans: action.response };
    }
    case Constants.GET_MINI_CART_SUCCESS: {
      return {
        ...state,
        miniCart: action.response,
        cartDetailsJson: { ...state.cartDetailsJson, orderDetailsView: { ...state.cartDetailsJson.orderDetailsView, ...action.response } },
      };
    }
    case Constants.GET_MINI_CART_ERROR: {
      return { ...state, miniCartError: true };
    }
    case Constants.RESET_MINI_CART_STATUS: {
      return { ...state, miniCart: {}, miniCartError: false };
    }
    case Constants.IS_EMPTY_ADDRESS: {
      return { ...state, isEmptyAddress: action.value };
    }
    case Constants.CEF_CART_ERROR:
      return { ...state, cartError: action.response, cartNtfyMsg: action.errorMessage };
    case Constants.UPDATE_PROMOCODE_FAILED:
      return { ...state, updatePromocodeFailed: action.response };
    case 'CREDIT_STATUS_TAGGING':
      return { ...state, creditStatusTagging: action.response };
    case 'BELOW_AGE_ERROR':
      return { ...state, belowAgeError: action.response };
    case 'CALL_PERFORMANCE':
      performanceMeasure('cart', action.response);
      break;
    case Constants.UPDATE_USER_DATA:
      return { ...state, mobilityUserData: action.response };
    case Constants.VALIDATE_ORDER_FAILED:
      return { ...state, isValidateOrderFailed: action.response };
    case 'UPDATE_NBX_OFFER_RECOMMENDATION':
      return { ...state, fwaOfferRecommendations: action.response };
    case Constants.NBX_FEEDBACK_RESPONSE:
      return { ...state, nbxFeedbackResponse: action.response };
      case 'GIFT_CARD_NBX_OFFER_RECOMMENDATION':
        return { ...state, giftCardFwaOfferRecommendations: action.response };
    case Constants.SET_CART_ERROR_FOR_REVIEW_ORDER_PAGE:
      return { ...state, showNoDatesErrorforReviewOrderPage: action.response };
    case Constants.POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS:
      return { ...state, updateProInstallationResponse: action.response };
    case 'SET_SAVE_5G_APPOINTMENT_STATUS':
      return { ...state, save5GappointmentStatus: action.value };
    case Constants.PREFETCH_SETUP_STATUS:
      return { ...state, prefetchRetrieveCartInSetupStatus: action?.response };
    case Constants.PREFETCH_IS_SETUP_CHANGE:
      return { ...state, prefetchIsSetupChange: action?.value };
    case Constants.SHOW_STREAMLINE_MINI_CART:
      return { ...state, showStreamlineMiniCart: action?.value };
    case Constants.BAR_CODE_OFFER_APPLIED_RESPONSE:
      return { ...state, updateBarCodeResponse: action?.response };
    default:
      return state;
  }
}
// UPDATE_INSTALL_TYPE_SUUCESS
export default cartDetails;
